<template>
  <div class="banner-container" v-if="data.length">
    <div class="banner-list">
      <div
        class="banner-item"
        v-for="(item, index) in data"
        :key="index"
        @click="bindClick(item)"
      >
        <img class="image" :src="item.img" alt="" />
        <div class="right">
          <div class="title">{{ item.title }}</div>
          <div class="desc">{{ item.content }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  methods: {
    bindClick(item) {
      if (this.$http._isApp()) {
        item.router && this.$betterwe.onAppPageRoute(item.router)
      } else {
        location.href =
          'https://member3.gymcity.com.cn/#/app-download?token=' +
          localStorage.getItem('token')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.banner-container {
  width: 100%;
  height: 52px;
  overflow-x: scroll;
  .banner-list {
    display: inline-flex;
    padding-right: 20px;
    .banner-item {
      width: 232px;
      height: 52px;
      display: flex;
      align-items: center;
      background: #ffffff;
      padding: 0px 12px 0px 17px;
      box-sizing: border-box;
      border-radius: 8px;
      margin-left: 20px;
      .image {
        width: 24px;
        height: 24px;
        background: #e5004a;
        border-radius: 6px;
      }
      .right {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        margin: 0px 8px;
        .title {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.8);
          line-height: 17px;
        }
        .desc {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 14px;
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #888888;
        }
      }
    }
  }
}
</style>
